export default __webpack_public_path__ + "noimage_thumbnail.d5514601bdfd6c5a300bf2c2806e71c6.png";